import { safeLocalStorage } from './storage';

/**
 * Cookie/storage consent, in one place.
 *
 * What the site stores:
 *  - `cookieConsent`            necessary: remembers the visitor's choice on the banner.
 *  - `selectedProductCategory`  optional: remembered across visits ONLY after "Accept".
 *  - session-only filters (sessionStorage): cleared when the tab closes, no consent needed.
 * The site sets no cookies of its own and runs no analytics. If analytics is ever added,
 * gate it on `hasConsented === true` from `useCookieConsent()`.
 */
export const CONSENT_STORAGE_KEY = 'cookieConsent';
export const REMEMBERED_CATEGORY_KEY = 'selectedProductCategory';

/** Storage that may only exist while the visitor has accepted; removed on reject/withdraw. */
const OPTIONAL_LOCAL_KEYS = [REMEMBERED_CATEGORY_KEY];

/** `true` accepted, `false` rejected, `null` no choice made yet. */
export function readStoredConsent(): boolean | null {
  const value = safeLocalStorage.getItem(CONSENT_STORAGE_KEY);
  if (value === 'accepted') return true;
  if (value === 'denied') return false;
  return null;
}

export function writeStoredConsent(accepted: boolean): void {
  safeLocalStorage.setItem(CONSENT_STORAGE_KEY, accepted ? 'accepted' : 'denied');
}

export function clearStoredConsent(): void {
  safeLocalStorage.removeItem(CONSENT_STORAGE_KEY);
}

export function clearOptionalStorage(): void {
  OPTIONAL_LOCAL_KEYS.forEach((key) => safeLocalStorage.removeItem(key));
}
